/* eslint-disable @typescript-eslint/no-explicit-any */
import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { AnyoComponent } from 'projects/app-core/src/app/models/AnyoComponent';
import { ToastService } from 'projects/app-core/src/app/services/toastr.service';
import { AuthService } from 'projects/app-core/src/auth/auth.service';
import { IAnyoError } from 'projects/app-core/src/models/errorModal';
import { AnyoRewardLedgerBaseGridData } from '../../../models/ledger/baseLedgerReqRes';
import {
  ExpertRewardFilter,
  ExpertRewardLedgerGridRequest,
  ExpertRewardLedgerGridResponse,
  ExpertRewardsGridMeta,
} from '../../../models/ledger/expertLedgerReqRes';
import {
  AdminAddRewardToLedger,
  AdminMakePayoutToExpertsRequest,
  RewardService,
} from '../../../services/rewards.service';
import {
  RewardsGridComponent,
  RewardsGridConfig,
  RewardsGridPayload,
  RewardTableType,
} from '../../../shared/components/rewards-grid/rewards-grid.component';

@Component({
  selector: 'app-manage-experts-rewards',
  templateUrl: './manage-experts-rewards.component.html',
  styleUrl: './manage-experts-rewards.component.scss',
})
export class ManageExpertsRewardsComponent
  extends AnyoComponent
  implements AfterViewInit
{
  constructor(
    auth: AuthService,
    private toastService: ToastService,
    public rewardService: RewardService,
  ) {
    super(auth);
  }
  ngAfterViewInit(): void {
    this.auth.currentAuthStatus.subscribe((user) => {
      if (user) {
        if (this.myComponent) {
          this.myComponent.getAllOrPendingGridData(false);
        }
      }
    });
  }

  @ViewChild('myComponent') myComponent!: RewardsGridComponent<
    ExpertRewardsGridMeta,
    ExpertRewardFilter,
    ExpertRewardLedgerGridRequest,
    ExpertRewardLedgerGridResponse
  >;

  // Configuration for the reusable rewards grid component
  rewardsGridConfig: RewardsGridConfig = {
    showExportButton: false, // Disable old single button
    showNewExportButton: true, // Enable new format export
    showOldExportButton: true, // Enable old format export
    showResetButton: true,
    showDateFilter: true,
    showConsolidateExportButton: true,
    showTabs: true,
    defaultTab: 'Complete',
    enablePayments: true,
    enableAddReward: true,
    enableLedgerView: true,
    pageSize: 10,
    pageSizeOptions: [10, 20, 50, 100],
    tableType: RewardTableType.CIRCLE_REWARDS,
  };

  title = 'Manage Experts Rewards';

  async ready(): Promise<void> {
    // Implementation for the abstract method from AnyoComponent
    // The actual data loading is now handled in ngAfterViewInit
    // if (this.myComponent) {
    console.log(this.myComponent);
    if (this.myComponent) {
      this.myComponent.getAllOrPendingGridData(false);
    }
    // }
  }

  // Event handlers for the reusable component
  onExport(data: RewardsGridPayload[]): void {
    // Handle export logic if needed
    console.log('Export data:', data);
  }

  onPayment(paymentData: AdminMakePayoutToExpertsRequest): void {
    this.rewardService.makePayout(paymentData).subscribe({
      next: () => {
        this.toastService.showSuccess('Payment Successful');
        this.myComponent.closePaymentModal();
        this.myComponent.getAllOrPendingGridData(true);
      },
      error: (e) => {
        const error = e.error as IAnyoError;
        this.toastService.showError(error.description);
      },
    });
  }

  onAddReward(rewardData: AdminAddRewardToLedger): void {
    this.rewardService.addRewardToLedger(rewardData).subscribe({
      next: () => {
        this.toastService.showSuccess('Reward Added Successfully');
        this.myComponent.closeAddRewardModal();
        this.myComponent.getAllOrPendingGridData(true);
      },
      error: (e) => {
        const error = e.error as IAnyoError;
        this.toastService.showError(error.description);
      },
    });
  }

  onViewLedger(
    data: AnyoRewardLedgerBaseGridData<ExpertRewardsGridMeta>,
  ): void {
    // Handle ledger view logic if needed
    console.log('View ledger for:', data);
  }

  onDataChange(
    data: AnyoRewardLedgerBaseGridData<ExpertRewardsGridMeta>[],
  ): void {
    // Handle data changes if needed
    console.log('Data changed:', data);
  }

  onFilterChange(filters: any): void {
    // Handle filter changes if needed
    console.log('Filters changed:', filters);
  }
}
